export default class Overlay {
  constructor() {
    if (!document.querySelector('.ac-map__overlay')) {
      const overlay = document.createElement('div');
      overlay.classList.add('ac-map__overlay');

      document.body.appendChild(overlay);
    }
  }
}
